import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import EmployerDashboardLayout from "@/app/Views/Companies/components/EmployerDashboardLayout.jsx";

import DataTable from "../../../components/Opportunities/data-table.jsx";
import SearchInput from "../../../components/Opportunities/search-input.jsx";
import StatisticsCard from "../../../components/Opportunities/statistics-card.jsx";
import { Icons } from "../../../components/ui/icons.jsx";
import { cn } from "../../../handlers/cn.utils.js";
import { getEmployerRoutes } from "../../../handlers/navigationItems.js";

function DashboardOverview() {
	const navigate = useNavigate();
	const [selectedRange, setSelectedRange] = useState("L7");
	const [searchTerm, setSearchTerm] = useState("");
	const actions = [
		{
			label: "View Candidate",
			icon: Icons.Preview,
			onClick: (row) => {
				navigate("/control-center/opportunity-details", { state: { candidate: row } });
			},
		},
	];

	return (
		<EmployerDashboardLayout navItems={getEmployerRoutes()} headingTitle="Activity Logs" headingIcon="arrow-left">
			<div className="h-full w-full overflow-hidden flex flex-col">
				<div className="flex-grow overflow-auto p-4 md:p-6 m-3 bg-background text-foreground">
					<div className="space-y-6">
						<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
							{[
								{
									label: "Total Candidates",
									value: 1000,
									icon: <Icons.Candidate className="w-5 h-5 text-primary-600" />,
								},
								{
									label: "L7 Emails Sent",
									value: 280,
									icon: <Icons.Mail className="w-5 h-5 text-primary-600" />,
								},
								{
									label: "L7 Emails Opened",
									value: 130,
									icon: <Icons.Preview className="w-5 h-5 text-primary-600" />,
								},
							].map((item, index) => {
								return <StatisticsCard key={index} label={item.label} value={item.value} icon={item.icon} />;
							})}
						</div>
						<div className="flex items-center justify-between">
							<div className="flex space-x-2">
								{[
									{ value: "L7", label: "L7" },
									{ value: "L14", label: "L14" },
									{ value: "L28", label: "L28" },
									{ value: "L56", label: "L56" },
									{ value: "L90", label: "L90" },
								].map((option) => (
									<button
										key={option.value}
										onClick={() => setSelectedRange(option.value)}
										className={cn(
											"px-4 py-2 rounded-full text-sm font-medium transition-colors",
											selectedRange === option.value
												? "bg-primary-100 text-primary-700 border border-primary-200"
												: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50",
										)}
									>
										{option.label}
										<span className="ml-2 text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full">
											{option.count}
										</span>
									</button>
								))}
							</div>
							<SearchInput
								searchTerm={searchTerm}
								onSearchChange={(value) => setSearchTerm(value)}
								placeholder="Search candidates..."
							/>
						</div>
						<DataTable
							columns={[
								{ header: "Candidate", accessor: "candidate", editable: false },
								{
									header: "L7 Open Rate",
									accessor: "l7openrate",
									editable: false,
									render: (value) => (value !== undefined ? `${value}%` : "-"),
								},
								{ header: "L7 Sent", accessor: "l7sent", editable: false },
								{ header: "L7 Opened", accessor: "l7opened", editable: false },
							]}
							data={[
								{
									full_name: "John Doe",
									email: "johndoe@gmail.com",
									l7openrate: 0,
									l7sent: 1,
									l7opened: 0,
									profile_image: "https://randomuser.me/api/portraits/men/22.jpg",
								},
								{
									full_name: "Jane Doe",
									email: "janedoe@gmail.com",
									l7openrate: 100,
									l7sent: 1,
									l7opened: 1,
									profile_image: "https://randomuser.me/api/portraits/women/44.jpg",
								},
							]}
							actions={actions}
						/>
					</div>
				</div>
			</div>
		</EmployerDashboardLayout>
	);
}

export default DashboardOverview;
